import React from 'react';

export type MarketContextValue = {
  market: string | null;
  country: string | null;
  language: string | null;
  isEvergreen: boolean;
};

const MarketContext = React.createContext<MarketContextValue>({
  market: null,
  country: null,
  language: null,
  isEvergreen: true,
});

export default MarketContext;
